
import { Component, OnInit, PLATFORM_ID, Inject, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { CommonModule, DATE_PIPE_DEFAULT_OPTIONS, isPlatformBrowser } from '@angular/common';
import { RouterOutlet } from '@angular/router';

import { MatDialogModule } from '@angular/material/dialog';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import { FacadeService } from '../../services/facade.service';
import { ProyectosService } from '../../services/proyectos.service';
import { AnalysisOptionsComponent } from '../../tools/analysis-options/analysis-options.component';
import { AnalysisServiceService } from '../../services/analysis-service/analysis-service.service';

import { Router } from '@angular/router'

@Component({
  selector: 'summary',
  standalone: true,
  imports: [
    HttpClientModule,
    MatDialogModule,
    CommonModule,
    RouterOutlet,
    MatSidenavModule,
    MatExpansionModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    MatCardModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatMenuModule,
    MatSlideToggleModule,
    AnalysisOptionsComponent,
    MatProgressBarModule],
  templateUrl: './summary.component.html',
  styleUrl: './summary.component.css'
})



export class SummaryComponent implements OnInit {
  isScreenLarge: boolean = false;
  activeEyeIcon: HTMLImageElement | null = null;

  excludeDigits: boolean;

  currentAnalysisMode: string;
  DesiredCEFRLevel;
  DesiredCEFRLevel_number;

  loaderActive: boolean;
  loaderActive2: boolean;
  loaderActiveFirstProject: boolean;

  loaderActiveSummary1: boolean;
  loaderActiveSummary2: boolean;
  loaderActiveSummary3: boolean;
  loaderActiveSummary4: boolean;

  cefr_short_words: boolean;
  lexical_short_words: boolean;
  short_words: boolean;

  isThereProject: boolean = false;

  verifyLoaderActive2: boolean;

  @Output() menuItemSelected = new EventEmitter<string>();

  onSelectMenuItem(menuItem: string) {
    this.menuItemSelected.emit(menuItem);
  }
  public project_data;
  public summary: any = {
    cefr: null,
    improvements: 0,
    flesch_kincaid: null,
    cefr_too_short_error: null,
    lexical: null,
    lexical_too_short_error: null,
    academic: null,
    words_level: null,
    sentence_count: null,
    too_short_error: null,
    word_count: null,
    issues: null,
    sentences_30: null,
    sentences_20: null,
    words_4: null,
    words_3: null,
    words_2: null,
    words_12: null,
    words_10: null,
    metrics: {},
    activar: {},
    llego_a_cefr: 0,
    sentences_data: []
  }

  public summary2: any = {
    cefr: null,
    improvements: 0,
    flesch_kincaid: null,
    cefr_too_short_error: null,
    lexical: null,
    lexical_too_short_error: null,
    academic: null,
    words_level: null,
    sentence_count: null,
    too_short_error: null,
    word_count: null,
    issues: null,
    sentences_30: null,
    sentences_20: null,
    words_4: null,
    words_3: null,
    words_2: null,
    words_12: null,
    words_10: null,
    metrics: {},
    activar: {},
    llego_a_cefr: 0,
    sentences_data: []
  }

  public summary3: any = {
    cefr: null,
    improvements: 0,
    flesch_kincaid: null,
    cefr_too_short_error: null,
    lexical: null,
    lexical_too_short_error: null,
    academic: null,
    words_level: null,
    sentence_count: null,
    too_short_error: null,
    word_count: null,
    issues: null,
    sentences_30: null,
    sentences_20: null,
    words_4: null,
    words_3: null,
    words_2: null,
    words_12: null,
    words_10: null,
    metrics: {},
    activar: {},
    llego_a_cefr: 0,
    sentences_data: []
  }

  public summary4: any = {
     cefr: null,
    improvements: 0,
    flesch_kincaid: null,
    cefr_too_short_error: null,
    lexical: null,
    lexical_too_short_error: null,
    academic: null,
    words_level: null,
    sentence_count: null,
    too_short_error: null,
    word_count: null,
    issues: null,
    sentences_30: null,
    sentences_20: null,
    words_4: null,
    words_3: null,
    words_2: null,
    words_12: null,
    words_10: null,
    metrics: {},
    activar: {},
    llego_a_cefr: 0,
    sentences_data: []
  }

  private proyectoSub;

  public hideEyeIconsForSafari1561 = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private http: HttpClient,
    public fachada: FacadeService,
    public proyectoService: ProyectosService,
    private analysisService: AnalysisServiceService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    localStorage.setItem("actual", "summary")
    this.initSubscribe();
    this.isButtonDisabled();
    this.hideEyeIconsForSafari1561 = false;
    // this.iniciarSummary();
    if (isPlatformBrowser(this.platformId)) {
      this.isScreenLarge = window.innerWidth > 1000;
      window.addEventListener('resize', this.onResize.bind(this));
    }

    this.analysisService.currentExcludeDigits.subscribe(value => this.excludeDigits = value);

    this.analysisService.currentAnalysisMode.subscribe(mode => {
      this.currentAnalysisMode = mode;
    });


    this.proyectoService.loaderCreatingProject$.subscribe(value => {
      if(value){
        this.loaderActive2 = true;
      }
      if(!value){
        this.loaderActive2 = false;
      }
    });


    this.analysisService.currentTargetCEFR.subscribe(level => {
      this.DesiredCEFRLevel = level;
      this.DesiredCEFRLevel_number = this.traducirCEFR(this.DesiredCEFRLevel)
    });


    this.proyectoService.refreshTextBox$.subscribe(() => {
      this.reiniciarSummary();
      this.refreshComponent();
      // Asignar valores derivados como antes
      this.cefr_short_words = false;
      this.lexical_short_words = false;
      this.short_words = false;
    });

    
      this.loaderActive = true;
     


    this.proyectoService.loader$.subscribe(loader => {
      if (this.loaderActive2) {
        this.loaderActive = false;
      } else {
        this.loaderActive = loader;
      }
    });

    this.proyectoService.loaderAnalyzing$.subscribe(loader => {
      if(loader){
        this.loaderActive2 = true;
      }
      if(!loader){
        this.loaderActive2 = false;

      }
    });

    this.proyectoService.verifyloaderAnalyzing$.subscribe(value => {
      if(value){
        this.verifyLoaderActive2 = true;
      }
      if(!value){
        this.verifyLoaderActive2 = false;
      }
    });

    setInterval(async () => {
      let pantalla_actual = localStorage.getItem("actual")
      if (pantalla_actual == "summary" && sessionStorage.getItem("id_project") && !this.verifyLoaderActive2) {
        if(sessionStorage.getItem("summary") !== "-" && !this.loaderActive){
          this.loaderActive2 = false;
          this.loaderActive = false;
          this.loaderActiveFirstProject = false;
          this.loaderActiveSummary1 = false;
          this.proyectoService.updateDisableCreatingProject(false);
          this.proyectoService.updateloader(false);
          this.proyectoService.updateloaderCreatingProject(false);
          this.iniciarSummary();
        }
        if(sessionStorage.getItem("summaryP2") !== "-" && !this.loaderActive){
          this.loaderActiveSummary2 = false
          this.iniciarSummary2();
        }
        if(sessionStorage.getItem("summaryP3") !== "-" && !this.loaderActive){
          this.loaderActiveSummary3 = false
                this.iniciarSummary3();
        }
        if(sessionStorage.getItem("summaryP4") !== "-" && !this.loaderActive){
          this.loaderActiveSummary4 = false

                this.iniciarSummary4();
        }
      }

  }, 20 * 1000); // 20 segundos

  }

  isButtonDisabled(): boolean {
    return !sessionStorage.getItem("text_UID");
  }

   public isSafariVersion1561(): boolean {
    const ua = navigator.userAgent;
    const safariMatch = ua.match(/Version\/([\d.]+) Safari\//);
    const isSafari = ua.includes("Safari") && ua.includes("Macintosh") && !ua.includes("Chrome");

    if (safariMatch && safariMatch[1] && isSafari) {
      return safariMatch[1] === "15.6.1";
    }

    return false;
  }

  private refreshComponent() {
    this.ngOnInit();
  }

  async initSubscribe() {
    console.log("PROYECTO---------------------")
    console.log(this.project_data)
    console.log("PROYECTO---------------------")

    if (!this.proyectoSub || this.proyectoSub.closed) {
      if (sessionStorage.getItem("text_UID")) {
         this.isThereProject = true;
      }
      else{
        this.isThereProject = false;
      }
      //Subscribimos al servicio para escuchar los datos
      this.proyectoSub = this.proyectoService.proyecto$.subscribe(async ({ proyecto, firstProject })=> {
        this.reiniciarSummary();
        if (!firstProject) {
          this.loaderActive = false;
          if (sessionStorage.getItem("text_UID")) {
            if(!this.loaderActiveFirstProject){
              this.loaderActive2 = true;
            }
            this.loaderActiveSummary1 = true;
            this.loaderActiveSummary2 = true;
            this.loaderActiveSummary3 = true;
            this.loaderActiveSummary4 = true;
          } else {
            this.loaderActive2 = false;
          }
        }
        if (firstProject) {
          this.loaderActive = false;
          if (sessionStorage.getItem("text_UID")) {
            this.loaderActiveFirstProject = true;
            this.loaderActiveSummary1 = true;
            this.loaderActiveSummary2 = true;
            this.loaderActiveSummary3 = true;
            this.loaderActiveSummary4 = true;
          } else {
            this.loaderActiveFirstProject = false;
          }
        }
        
        console.log("Update de data --Reporta: Summary--")
        this.project_data = proyecto;
        console.log("::: Proyecto actualizado :::")
        console.log(this.project_data)
        let actualizo = await this.fachada.verificarStatusproject(this.http, sessionStorage.getItem("id_project"))
        console.log("Existe el proyecto::::::", actualizo)
        if (actualizo.update){
          console.log("DEBUG:::::Actualizamos el proyecto, porque no existe")
          this.project_data.text_UID = actualizo.text_UID
          sessionStorage.setItem("text_UID", actualizo.text_UID)
        }
        

        if(sessionStorage.getItem("id_project")){
           this.iniciarSummary();
            this.iniciarSummary2();
              this.iniciarSummary3();
        }
      });
    }
  }

  onResize() {
    this.isScreenLarge = window.innerWidth > 1000;
  }

  getFleschKincaidDisplay(): string {
  const idProject = sessionStorage.getItem("id_project");

  // Si no hay id_project, mostramos "--"
  if (!idProject) return "--";

  // Si existe summary2 y tiene un valor null, mostramos "0.00"
  if (this.summary2 && this.summary2.flesch_kincaid == null) return "0.00";

  // Si tiene valor definido, lo mostramos tal cual
  return this.summary2?.flesch_kincaid ?? "--";
}

getLexicalDisplay(): string {
  const idProject = sessionStorage.getItem("id_project");

  // Si no hay id_project, mostramos "--"
  if (!idProject) return "--";

  // Si existe summary2 y tiene un valor null, mostramos "0.00"
  if (this.summary2 && this.summary2.lexical == null) return "0.00";

  // Si tiene valor definido, lo mostramos tal cual
  return this.summary2?.lexical ?? "--";
}

getAcademicDisplay(): string {
  const idProject = sessionStorage.getItem("id_project");

  // Si no hay id_project, mostramos "--"
  if (!idProject) return "--";

  // Si existe summary2 y tiene un valor null, mostramos "0.00"
  if (this.summary3 && this.summary3.academic == null) return "0.00";

  // Si tiene valor definido, lo mostramos tal cual
  return this.summary3?.academic ?? "--";
}

getWordsLevelDisplay(): string {
  const idProject = sessionStorage.getItem("id_project");

  // Si no hay id_project, mostramos "--"
  if (!idProject) return "--";

  // Si existe summary2 y tiene un valor null, mostramos "0.00"
  if (this.summary3 && this.summary3.words_level == null) return "0.00";

  // Si tiene valor definido, lo mostramos tal cual
  return this.summary3?.words_level ?? "--";
}



  getBoxLineColorKincaid(value: number): string {
    if (value <= 6) {
      return 'box-line-green';
    } else if (value > 6 && value <= 13) {
      return 'box-line-yellow';
    } else if (value > 13) {
      return 'box-line-red';
    }
    return 'box-line';
  }

  getBoxLineColorVOCD(value: number): string {
    if (value <= 70) {
      return 'box-line-green';
    } else if (value > 70 && value <= 80) {
      return 'box-line-yellow';
    } else if (value > 80) {
      return 'box-line-red';
    }
    return 'box-line';
  }

  getBoxLineColorAcademic(value: number): string {
    if (value <= .5) {
      return 'box-line-green';
    } else if (value > .5 && value <= 3) {
      return 'box-line-yellow';
    } else if (value > 3) {
      return 'box-line-red';
    }
    return 'box-line';
  }

  getBoxLineColorWordsLevel(value: number): string {
    if (value <= 6) {
      return 'box-line-red';
    } else if (value > 6 && value <= 8) {
      return 'box-line-yellow';
    } else if (value > 8) {
      return 'box-line-green';
    }
    return 'box-line';
  }

  getTextLineFlesch(value: number): string {
    if (value <= 1) {
      return 'High Readability: 1st Grade Reading Level';
    } else if (value > 1 && value <= 2) {
      return 'High Readability: 1st Grade Reading Level';
    } else if (value > 2 && value <= 3) {
      return 'High Readability: 2nd Grade Reading Level';
    } else if (value > 3 && value <= 4) {
      return 'High Readability: 3rd Grade Reading Level';
    } else if (value > 4 && value <= 5) {
      return 'High Readability: 4th Grade Reading Level';
    } else if (value > 5 && value <= 6) {
      return 'High Readability: 5th Grade Reading Level';
    } else if (value > 6 && value <= 7) {
      return 'Moderate Readability: 6th Grade Reading Level';
    } else if (value > 7 && value <= 8) {
      return 'Moderate Readability: 7th Grade Reading Level';
    } else if (value > 8 && value <= 9) {
      return 'Moderate Readability: 8th Grade Reading Level';
    } else if (value > 9 && value <= 10) {
      return 'Moderate Readability: 9th Grade Reading Level';
    } else if (value > 10 && value <= 11) {
      return 'Moderate Readability: 10th Grade Reading Level';
    } else if (value > 11 && value <= 12) {
      return 'Moderate Readability: 11th Grade Reading Level';
    } else if (value > 12 && value <= 13) {
      return 'Moderate Readability: 12th Grade Reading Level';
    } else if (value > 13 && value <= 16) {
      return 'Low Readability: University Student Reading Level';
    } else if (value > 16 && value <= 18) {
      return 'Very Low Readability: University Graduate Reading Level';
    } else if (value > 18) {
      return 'Very Low Readability: University Graduate Reading Level';
    }

    return '';
  }

  getTextLineLexical(value: number): string {
    if (value <= 65) {
      return 'Low Vocabulary Diversity';
    } else if (value > 65 && value <= 80) {
      return 'Medium Vocabulary Diversity';
    } else if (value > 80) {
      return 'High Vocabulary Diversity';
    }
    return '';
  }

  getTextLineAcademic(value: number): string {
    if (value <= .5) {
      return 'Low % of AWL Words (Tokens)';
    } else if (value > .5 && value <= 3) {
      return 'Medium % of AWL Words (Tokens)';
    } else if (value > 3) {
      return 'High % of AWL Words (Tokens)';
    }
    return 'box-line';
  }

  mapToPercentage(value) {
  if (value <= 0) return 0;

  if (value <= 0.5) {
    // Primer tramo: 0 a 0.5 → 0% a 30%
    return (value / 0.5) * 30;
  }

  if (value <= 3) {
    // Segundo tramo: 0.5 a 3 → 30% a 80%
    return 30 + ((value - 0.5) / (3 - 0.5)) * 50;
  }

  else{
    // Segundo tramo: 0.5 a 3 → 30% a 80%
    return 100;
  }
 
}

  getTextLineWordsLevel(value: number): string {
    if ( value <= 6) {
      return 'Low % of B1 Level Words (Tokens)';
    } else if (value > 6 && value <= 8) {
      return 'Medium % of B1 Level Words (Tokens)';
    } else if (value > 8) {
      return 'High % of B1 Level Words (Tokens)';
    }
    return 'box-line';
  }

  isMatchingLevel(level): boolean {
    let temp = this.summary.cefr.split("+")[0]
    return level === temp;
  }


  //Para el cambio de color de los ojos
  toggleEyeIcon_Sentence(event: Event, array_data = null): void {
    const element = event.target as HTMLImageElement;
    // Si hay un icono activo y no es el mismo que se hizo clic, restablecer su imagen
    if (this.activeEyeIcon && this.activeEyeIcon !== element) {
      this.activeEyeIcon.src = './assets/images/eye-icon.svg';
    }

    // Cambiar la imagen del icono actual
    if (element.src.includes('eye-icon.svg')) {
      //Prende 
      this.proyectoService.realizarMarcadoSentencesStatis(array_data, "sentence", this.http, this.excludeDigits, 'summary')
      element.src = './assets/images/yellow_icons/eye-on-icon.svg';
      this.activeEyeIcon = element; // Establecer el icono actual como activo
    } else {
      //Apaga
      this.proyectoService.undoMarcadoMultiple(this.http)
      element.src = './assets/images/eye-icon.svg';
      this.activeEyeIcon = null; // No hay icono activo
    }
  }

  toggleEyeIcon_Words(event: Event, array_data = null): void {
    const element = event.target as HTMLImageElement;
    // Si hay un icono activo y no es el mismo que se hizo clic, restablecer su imagen
    if (this.activeEyeIcon && this.activeEyeIcon !== element) {
      this.activeEyeIcon.src = './assets/images/eye-icon.svg';
    }

    // Cambiar la imagen del icono actual
    if (element.src.includes('eye-icon.svg')) {
      //Prende 
      this.proyectoService.realizarMarcadoTokensWordsSummary(array_data, "k1", this.http)
      element.src = './assets/images/yellow_icons/eye-on-icon.svg';
      this.activeEyeIcon = element; // Establecer el icono actual como activo
    } else {
      //Apaga
      this.proyectoService.undoMarcadoMultiple(this.http)
      element.src = './assets/images/eye-icon.svg';
      this.activeEyeIcon = null; // No hay icono activo
    }
  }

  toggleEyeIcon(event: Event, array_data = null): void {
    const element = event.target as HTMLImageElement;
    // Si hay un icono activo y no es el mismo que se hizo clic, restablecer su imagen
    if (this.activeEyeIcon && this.activeEyeIcon !== element) {
      this.activeEyeIcon.src = './assets/images/eye-icon.svg';
    }

    // Cambiar la imagen del icono actual
    if (element.src.includes('eye-icon.svg')) {
      //Prende 
      this.proyectoService.realizarMarcado3Summary(array_data, "k1", this.http)
      element.src = './assets/images/yellow_icons/eye-on-icon.svg';
      this.activeEyeIcon = element; // Establecer el icono actual como activo
    } else {
      //Apaga
      this.proyectoService.undoMarcadoMultiple(this.http)
      element.src = './assets/images/eye-icon.svg';
      this.activeEyeIcon = null; // No hay icono activo
    }
  }
  status: any;

  unica_peticion3: boolean = false;
  async iniciarSummary() {
let pantalla_actual = localStorage.getItem("actual")
    if (pantalla_actual == "summary") {
      // -------------------------------------------------
      // -------------------------------------------------
      // -----------------ENDPOINT 1----------------------
      // -------------------------------------------------
      // -------------------------------------------------
      // Intentar recuperar el resumen desde sessionStorage
      const memoryStorage = sessionStorage.getItem("summary");
      if (memoryStorage) {
        if(memoryStorage !== "-"){
        try {
          // Si existe, convertirlo de JSON string a objeto y asignarlo
          this.summary = JSON.parse(memoryStorage);

          this.cefr_short_words = this.summary.cefr_too_short_error;

          this.analysisService.changeAchiveCEFR(this.summary.cefr);
          this.analysisService.changeAnalysisMode(this.project_data['config_json']['analysisMode']);
            
        } catch (error) {
          console.log("Ocurrió un error");

          if (error instanceof TypeError) {

          } else if (error.message && error.message.startsWith("Error del servidor")) {
            console.error("Error de servidor");
            console.error(error.message);
            sessionStorage.removeItem('summary');
          } else {
            console.error("Otro tipo de error:");
            console.error(error);
            sessionStorage.removeItem('summary');
          }

        } finally {
          this.loaderActive2 = false;
          this.loaderActive = false;
          this.loaderActiveFirstProject = false;
          this.loaderActiveSummary1 = false;
          this.proyectoService.updateDisableCreatingProject(false);
          this.proyectoService.updateloader(false);
          this.proyectoService.updateloaderCreatingProject(false);
        }
      }
      } else {
        sessionStorage.setItem("summary", "-");
        // Si no hay datos en sessionStorage, hacer la petición normalmente
        await new Promise(resolve => setTimeout(resolve, 10));

        try {
          let textUID = sessionStorage.getItem('text_UID');
          let respuesta = await this.fachada.getSummaryOfProject(
            this.http,
            textUID,
            localStorage.getItem("text-inspector-django-token")
          );

          this.summary = respuesta;

          this.cefr_short_words = this.summary.cefr_too_short_error;

          // Guardar la respuesta en sessionStorage
          sessionStorage.setItem("summary", JSON.stringify(this.summary));

          this.analysisService.changeAchiveCEFR(this.summary.cefr);
          this.analysisService.changeAnalysisMode(this.project_data['config_json']['analysisMode']);


          if (sessionStorage.getItem("text_UID")) {
              this.isThereProject = true;
            }
            else{
              this.isThereProject = false;
            }


          this.status = 200
        } catch (error) {
          if (error?.status === 0) {
            console.error("Error 500: Error interno del servidor (summary)");
            sessionStorage.removeItem('summary');
            this.status = 0

          }
          if (error instanceof TypeError) {

          } else if (error.message && error.message.startsWith("Error del servidor")) {
            console.error("Error de servidor");
            console.error(error.message);
            sessionStorage.removeItem('summary');
          } else {
            console.error("Otro tipo de error:");
            console.error(error);
            sessionStorage.removeItem('summary');
          }

          this.status = error?.status;

        } finally {

          if (this.status === 0) {
            this.loaderActive2 = true;
            this.loaderActive = true;
            this.loaderActiveFirstProject = true;
            this.loaderActiveSummary1 = true;
            this.proyectoService.updateDisableCreatingProject(true);
            this.proyectoService.updateloader(true);
            setTimeout(() => {
              this.iniciarSummary();
            }, 100);
          } else {
            this.loaderActive2 = false;
            this.loaderActive = false;
            this.loaderActiveFirstProject = false;
            this.loaderActiveSummary1 = false;
            this.proyectoService.updateDisableCreatingProject(false);
            this.proyectoService.updateloader(false);
            this.proyectoService.updateloaderCreatingProject(false);
             setTimeout(() => {
              this.iniciarSummary();
            }, 100);
          }
        }
      }
      }else{
      console.log(`summary no es la pantalla actual así que bloqueamos peticiones`)
    }
  }

  status2: any;
  async iniciarSummary2() {
    // -------------------------------------------------
    // -------------------------------------------------
    // -----------------ENDPOINT 2----------------------
    // -------------------------------------------------
    // -------------------------------------------------

     let pantalla_actual = localStorage.getItem("actual")
    if (pantalla_actual == "summary") {
      // Intentar recuperar el resumen desde sessionStorage
      const memoryStorage2 = sessionStorage.getItem("summaryP2");
      if (memoryStorage2) {
        if(memoryStorage2 !== "-"){
        try {
          // Si existe, convertirlo de JSON string a objeto y asignarlo
          this.summary2 = JSON.parse(memoryStorage2);

          // Asignar valores derivados como antes
           setTimeout(() => {
            this.getFleschKincaidDisplay()
            this.getLexicalDisplay()
          }, 100);
          
          this.lexical_short_words = this.summary2.lexical_too_short_error;
          this.short_words = this.summary2.too_short_error;

        } catch (error) {
          console.log("Ocurrió un error (summary2)");
          if (error instanceof TypeError) {

          } else if (error.message && error.message.startsWith("Error del servidor")) {
            console.error("Error de servidor (summary2)");
            console.error(error.message);
            sessionStorage.removeItem('summaryP2');
          } else {
            console.error("Otro tipo de error: (summary2)");
            console.error(error);
            sessionStorage.removeItem('summaryP2');
          }
          // Guardamos el status del error si viene disponible

        } finally {
          this.loaderActiveSummary2 = false;
        }
      }
      } else {
        sessionStorage.setItem("summaryP2", "-");
        // Si no hay datos en sessionStorage, hacer la petición normalmente
        await new Promise(resolve => setTimeout(resolve, 10));

        try {
          let textUID = sessionStorage.getItem('text_UID');
          let respuesta2 = await this.fachada.getSummary2OfProject(
            this.http,
            textUID,
            localStorage.getItem("text-inspector-django-token")
          );

          this.summary2 = respuesta2;

          // Guardar la respuesta en sessionStorage
          sessionStorage.setItem("summaryP2", JSON.stringify(this.summary2));

         setTimeout(() => {
            this.getFleschKincaidDisplay()
            this.getLexicalDisplay()
          }, 100);

          this.lexical_short_words = this.summary2.lexical_too_short_error;
          this.short_words = this.summary2.too_short_error;

          if (sessionStorage.getItem("text_UID")) {
              this.isThereProject = true;
            }
            else{
              this.isThereProject = false;
            }

          this.status2 = 200;

        } catch (error) {
          console.log("Ocurrió un error (summary2)");
          if (error?.status === 0) {
            console.error("Error 500: Error interno del servidor (summary2)");
            sessionStorage.removeItem('summaryP2');
            this.status2 = 0
          }
          if (error instanceof TypeError) {

          } else if (error.message && error.message.startsWith("Error del servidor")) {
            console.error("Error de servidor (summary2)");
            console.error(error.message);
            sessionStorage.removeItem('summaryP2');
          } else {
            console.error("Otro tipo de error:");
            console.error(error);
            sessionStorage.removeItem('summaryP2');
          }

          this.status2 = error?.status;

        } finally {
          if (this.status2 === 0) {
            this.loaderActiveSummary2 = true
            setTimeout(() => {
              this.iniciarSummary2();
            }, 100);
          } else {
            this.loaderActiveSummary2 = false
             setTimeout(() => {
              this.iniciarSummary2();
            }, 100);
          }
        }
      }
       }else{
      console.log(`summary no es la pantalla actual así que bloqueamos peticiones`)
    }
  }

  status3: any;
  async iniciarSummary3() {
     let pantalla_actual = localStorage.getItem("actual")
    if (pantalla_actual == "summary") {
    // -------------------------------------------------
    // -------------------------------------------------
    // -----------------ENDPOINT 3----------------------
    // -------------------------------------------------
    // -------------------------------------------------
      // Intentar recuperar el resumen desde sessionStorage
      const memoryStorage3 = sessionStorage.getItem("summaryP3");
      if (memoryStorage3) {
        if(memoryStorage3 !== "-"){
        try {
          // Si existe, convertirlo de JSON string a objeto y asignarlo
          this.summary3 = JSON.parse(memoryStorage3);

          this.iniciarSummary4();

          setTimeout(() => {
            this.getAcademicDisplay()
            this.getWordsLevelDisplay()
          }, 100);


        } catch (error) {
          console.log("Ocurrió un error (summary3)");

          if (error instanceof TypeError) {

          } else if (error.message && error.message.startsWith("Error del servidor")) {
            console.error("Error de servidor (summary3)");
            console.error(error.message);
            sessionStorage.removeItem('summaryP3');
          } else {
            console.error("Otro tipo de error: (summary3)");
            console.error(error);
            sessionStorage.removeItem('summaryP3');
          }

        } finally {
          this.loaderActiveSummary3 = false;
        }
      }
      } else {
        

        sessionStorage.setItem("summaryP3", "-");
        // Si no hay datos en sessionStorage, hacer la petición normalmente
        await new Promise(resolve => setTimeout(resolve, 10));

        try {
          let textUID = sessionStorage.getItem('text_UID');


          let respuesta3 = await this.fachada.getSummary3OfProject(
            this.http,
            textUID,
            localStorage.getItem("text-inspector-django-token")
          );

          this.summary3 = respuesta3;

          // Guardar la respuesta en sessionStorage
          sessionStorage.setItem("summaryP3", JSON.stringify(this.summary3));

         setTimeout(() => {
            this.getAcademicDisplay()
            this.getWordsLevelDisplay()
          }, 100);


          if (sessionStorage.getItem("text_UID")) {
              this.isThereProject = true;
            }
            else{
              this.isThereProject = false;
            }


          this.status3 = 200

        } catch (error) {
          console.log("Ocurrió un error (summary3)");

          if (error?.status === 0) {
            console.error("Error 500: Error interno del servidor (summary3)");
            sessionStorage.removeItem('summaryP3');

          }
          if (error instanceof TypeError) {

          } else if (error.message && error.message.startsWith("Error del servidor")) {
            console.error("Error de servidor (summary3)");
            console.error(error.message);
            sessionStorage.removeItem('summaryP3');
          } else {
            console.error("Otro tipo de error: (summary3)");
            console.error(error);
            sessionStorage.removeItem('summaryP3');
          }

          this.status3 = error?.status;

        } finally {
          if (this.status3 === 0) {
            this.loaderActiveSummary3 = true;
            setTimeout(() => {
              this.iniciarSummary3();
              this.iniciarSummary4();
            }, 100);
          }
          else {
            this.loaderActiveSummary3 = false;
             setTimeout(() => {
              this.iniciarSummary3();
            }, 100);
            
          }
          
        }
      
      }
      }else{
      console.log(`summary no es la pantalla actual así que bloqueamos peticiones`)
    }
  }

  status4: any;
  async iniciarSummary4() {
     let pantalla_actual = localStorage.getItem("actual")
    if (pantalla_actual == "summary") {
    // -------------------------------------------------
    // -------------------------------------------------
    // -----------------ENDPOINT 4----------------------
    // -------------------------------------------------
    // -------------------------------------------------
      // Intentar recuperar el resumen desde sessionStorage
      const memoryStorage4 = sessionStorage.getItem("summaryP4");
      if (memoryStorage4) {
        if(memoryStorage4 !== "-"){
        try {
          // Si existe, convertirlo de JSON string a objeto y asignarlo
          this.summary4 = JSON.parse(memoryStorage4);

          setTimeout(() => {
            this.getAcademicDisplay()
            this.getWordsLevelDisplay()
          }, 100);


        } catch (error) {
          console.log("Ocurrió un error (summary4)");

          if (error instanceof TypeError) {

          } else if (error.message && error.message.startsWith("Error del servidor")) {
            console.error("Error de servidor (summary4)");
            console.error(error.message);
            sessionStorage.removeItem('summaryP4');
          } else {
            console.error("Otro tipo de error: (summary4)");
            console.error(error);
            sessionStorage.removeItem('summaryP4');
          }

        } finally {
          this.loaderActiveSummary4 = false;
        }
      }
      } else {
        

        sessionStorage.setItem("summaryP4", "-");
        // Si no hay datos en sessionStorage, hacer la petición normalmente
        await new Promise(resolve => setTimeout(resolve, 10));

        try {
          let textUID = sessionStorage.getItem('text_UID');


          let respuesta4 = await this.fachada.getSummary4OfProject(
            this.http,
            textUID,
            localStorage.getItem("text-inspector-django-token")
          );

          this.summary4 = respuesta4;

          // Guardar la respuesta en sessionStorage
          sessionStorage.setItem("summaryP4", JSON.stringify(this.summary4));

         setTimeout(() => {
            this.getAcademicDisplay()
            this.getWordsLevelDisplay()
          }, 100);


          if (sessionStorage.getItem("text_UID")) {
              this.isThereProject = true;
            }
            else{
              this.isThereProject = false;
            }


          this.status4 = 200

        } catch (error) {
          console.log("Ocurrió un error (summary4)");

          if (error?.status === 0) {
            console.error("Error 500: Error interno del servidor (summary4)");
            sessionStorage.removeItem('summaryP4');

          }
          if (error instanceof TypeError) {

          } else if (error.message && error.message.startsWith("Error del servidor")) {
            console.error("Error de servidor (summary4)");
            console.error(error.message);
            sessionStorage.removeItem('summaryP4');
          } else {
            console.error("Otro tipo de error: (summary4)");
            console.error(error);
            sessionStorage.removeItem('summaryP4');
          }

          this.status4 = error?.status;

        } finally {
          if (this.status4 === 0) {
            this.loaderActiveSummary4 = true;
            setTimeout(() => {
              this.iniciarSummary4();
            }, 100);
          }
          else {
            this.loaderActiveSummary4 = false;
             setTimeout(() => {
              this.iniciarSummary4();
            }, 100);
            
          }
          
        }
      
      }
      }else{
      console.log(`summary no es la pantalla actual así que bloqueamos peticiones`)
    }
  }

  reiniciarSummary(): void {
    this.summary.cefr = null,
      this.summary.improvements = 0,
      this.summary.flesch_kincaid = null,
      this.summary.cefr_too_short_error = null,
      this.summary.lexical = null,
      this.summary.lexical_too_short_error = null,
      this.summary.academic = null,
      this.summary.words_level = null,
      this.summary.sentence_count = null,
      this.summary.too_short_error = null,
      this.summary.word_count = null,
      this.summary.issues = null,
      this.summary.sentences_30 = null,
      this.summary.sentences_20 = null,
      this.summary.words_4 = null,
      this.summary.words_3 = null,
      this.summary.words_2 = null,
      this.summary.words_12 = null,
      this.summary.words_10 = null,
      this.summary.metrics = {}


    this.summary2.cefr = null,
      this.summary2.improvements = 0,
      this.summary2.flesch_kincaid = null,
      this.summary2.cefr_too_short_error = null,
      this.summary2.lexical = null,
      this.summary2.lexical_too_short_error = null,
      this.summary2.academic = null,
      this.summary2.words_level = null,
      this.summary2.sentence_count = null,
      this.summary2.too_short_error = null,
      this.summary2.word_count = null,
      this.summary2.issues = null,
      this.summary2.sentences_30 = null,
      this.summary2.sentences_20 = null,
      this.summary2.words_4 = null,
      this.summary2.words_3 = null,
      this.summary2.words_2 = null,
      this.summary2.words_12 = null,
      this.summary2.words_10 = null,
      this.summary2.metrics = {}


    this.summary3.cefr = null,
      this.summary3.improvements = 0,
      this.summary3.flesch_kincaid = null,
      this.summary3.cefr_too_short_error = null,
      this.summary3.lexical = null,
      this.summary3.lexical_too_short_error = null,
      this.summary3.academic = null,
      this.summary3.words_level = null,
      this.summary3.sentence_count = null,
      this.summary3.too_short_error = null,
      this.summary3.word_count = null,
      this.summary3.issues = null,
      this.summary3.sentences_30 = null,
      this.summary3.sentences_20 = null,
      this.summary3.words_4 = null,
      this.summary3.words_3 = null,
      this.summary3.words_2 = null,
      this.summary3.words_12 = null,
      this.summary3.words_10 = null,
      this.summary3.metrics = {}


    
    this.summary4.cefr = null,
      this.summary4.improvements = 0,
      this.summary4.flesch_kincaid = null,
      this.summary4.cefr_too_short_error = null,
      this.summary4.lexical = null,
      this.summary4.lexical_too_short_error = null,
      this.summary4.academic = null,
      this.summary4.words_level = null,
      this.summary4.sentence_count = null,
      this.summary4.too_short_error = null,
      this.summary4.word_count = null,
      this.summary4.issues = null,
      this.summary4.sentences_30 = null,
      this.summary4.sentences_20 = null,
      this.summary4.words_4 = null,
      this.summary4.words_3 = null,
      this.summary4.words_2 = null,
      this.summary4.words_12 = null,
      this.summary4.words_10 = null,
      this.summary4.metrics = {}
  }

  

  isCEFRRange(validar, rangos) {
    validar = this.traducirCEFR(validar)
    // Verificar si el rango está completamente entre 1 y 15
    return validar >= rangos[0] && validar <= rangos[1];
  }

  traducirCEFR(CEFR) {
    const traduccion = {
      "A1": 1, "A1+": 2, "A2": 3, "A2+": 4,
      "B1": 5, "B1+": 6, "B2": 7, "B2+": 8,
      "C1": 9, "C1+": 10, "C2": 11, "C2+": 12,
      "D1": 13, "D1+": 14, "D2": 15
    };

    return traduccion[CEFR] || 0;
  }

  countKeys(obj: Record<string, any>): number {
    const keyCount = Object.keys(obj).length;
    return keyCount;
  }

}
